/**
 * Per-page browser tab titles ("Leads · FinderlyFix Partners"): every tab
 * used to read "FinderlyFix Partners", which is useless with three open.
 * Titles name the page the way the rail does; setup steps use their step
 * title. Unknown paths say so.
 */
import { useEffect } from 'react';
import { matchPath } from './router';
import { stepBySlug } from './setup/steps';

export const APP_NAME = 'FinderlyFix Partners';

const PAGES: Array<[string, string]> = [
  ['/dashboard', 'Dashboard'],
  ['/leads', 'Leads'],
  ['/leads/:id', 'Lead'],
  ['/billing', 'Billing'],
  ['/pages/:slug', 'Your page'],
  ['/sites', 'Sites & keys'],
  ['/config', 'Widget settings'],
  ['/destinations', 'Destinations'],
  ['/destinations/:id', 'Destination'],
  ['/contractors', 'Contractors'],
  ['/routing', 'Routing rules'],
  ['/team', 'Team & roles'],
  ['/agent', 'AI agent access'],
  ['/oauth/consent', 'Agent sign-in'],
  ['/audit', 'Audit log'],
  ['/settings', 'Organisation'],
  ['/ops', 'Pending approvals'],
  ['/ops/partners', 'All partners'],
  ['/ops/partners/:id', 'Partner'],
  ['/ops/billing', 'Billing (admin)'],
  ['/account', 'Your account'],
  ['/account/revert', 'This wasn’t me'],
  ['/account/google-revert', 'This wasn’t me'],
  ['/agent/change', 'AI agent change'],
  ['/claim', 'Take ownership'],
  ['/signup/report', 'This wasn’t us'],
  ['/invite/accept', 'Team invitation'],
  ['/sign-in', 'Sign in'],
  ['/welcome', 'Welcome'],
  ['/docs/ai-setup', 'AI-assisted setup'],
  ['/legal/partner-terms', 'Partner Terms'],
  ['/legal/dpa', 'Data processing addendum'],
  ['/share/:token', 'Shared stats'],
  ['/l/:token', 'Lead brief'],
  ['/q/:token', 'Your quote'],
];

/** The page name for `path`, or null for an unknown path. */
export function pageName(path: string): string | null {
  for (const [pattern, name] of PAGES) if (matchPath(pattern, path)) return name;
  const setup = matchPath('/setup/:slug', path);
  if (setup) return stepBySlug(setup.slug ?? '')?.title ?? null;
  return null;
}

export function titleFor(path: string): string {
  if (path === '/' || path === '') return APP_NAME;
  return `${pageName(path) ?? 'Page not found'} · ${APP_NAME}`;
}

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
